const allData={

    gridData : {
      gridData1 : [
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/381e915d58d2b9759725c30a9f2c3a0f/razer-blade-15-2022-laptop-500x500.jpg",
          title:"LAPTOPS",
          des:"Sleek high-performance gaming laptops",
          link:"/"
        },
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/381e915d58d2b9759725c30a9f2c3a0f/desktops-components-category--500x500.jpg",
          title:"DESKTOPS & COMPONENTS",
          des:"Engineered for enthusiasts and designed for performance",
          link:"/"
        },
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/381e915d58d2b9759725c30a9f2c3a0f/accessories-category-500x500.jpg",
          title:"ACCESSORIES",
          des:"Crafting the perfect gaming experience",
          link:"/"
        }
      ],
      gridData2 : [
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/8127df0df8433ada296a732b23f3b9b4/mice-category-500x500.jpg",
          title:"MICE",
          des:"Pixel-perfect precision for any hand size and grip style",
          link:"/"
        },
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/8127df0df8433ada296a732b23f3b9b4/mousemats-category-500x500.jpg",
          title:"MOUSE MATS",
          des:"Soft, hard, and hybrid designs to enhance your control",
          link:"/"
        },
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/8127df0df8433ada296a732b23f3b9b4/keyboards-category-500x500.jpg",
          title:"KEYBOARDS",
          des:"Optical, mechanical, and every type in between",
          link:"/"
        }
      ],
      gridData3 : [
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/8127df0df8433ada296a732b23f3b9b4/headsets-category-500x500.jpg",
          title:"HEADSETS",
          des:"Tuned for gaming, lifestyle, or a perfect mix of both",
          link:"/"
        },
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/8127df0df8433ada296a732b23f3b9b4/speakers-category-500x500.jpg",
          title:"SPEAKERS",
          des:"Set the soundstage for full-range immersion",
          link:"/"
        },
        {
          img:"https://assets2.razerzone.com/images/pnx.assets/8127df0df8433ada296a732b23f3b9b4/chairs-category-500x500.jpg",
          title:"CHAIRS",
          des:"Perfecting the science of comfort and support",
          link:"/"
        }
      ],



        gridData4 : [
            {
              img:"https://assets2.razerzone.com/images/pnx.assets/6db17f7284da185264c3018f26bef57a/webcams-category-500x500.jpg",
              title:"WEBCAMS",
              des:"Stunning visual fidelity for streaming and productivity",
              link:"/"
            },
            {
              img:"https://assets2.razerzone.com/images/pnx.assets/6db17f7284da185264c3018f26bef57a/microphones-category-500x500.jpg",
              title:"MICROPHONES",
              des:"Engineered for crystal-clear voice pickup",
              link:"/"
            },
            {
              img:"https://assets2.razerzone.com/images/pnx.assets/6db17f7284da185264c3018f26bef57a/capturecard&others-category-500x500.jpg",
              title:"RAZER KISHI",
              des:"For a professional streaming advantage.",
              link:"/"
            }
          ],
        gridData5 : [
            {
              img:"https://assets2.razerzone.com/images/pnx.assets/cf07588e1e08bf7767da32b1181bc4bf/razer-synapse-category-500x500.jpg",
              title:"RAZER SYNAPSE",
              des:"Maximize your unfair advantage with Razer Synapse 3, the unified cloud-based hardware configuration tool that takes your Razer devices to the next level. ",
              link:"/"
            },
            {
              img:"https://assets2.razerzone.com/images/pnx.assets/cf07588e1e08bf7767da32b1181bc4bf/razer-chroma-rgb-category-500x500.jpg",
              title:"RAZER CHROMA™ RGB",
              des:"Experience full RGB customization and deeper immersion with the world’s largest lighting ecosystem that supports hundreds of games and thousands of devices.",
              link:"/"
            },
            {
              img:"https://assets2.razerzone.com/images/pnx.assets/cf07588e1e08bf7767da32b1181bc4bf/razer-cortex-category-500x500.jpg",
              title:"RAZER CORTEX",
              des:"Unlock your PC’s full potential and enhance your gameplay with Razer: Cortex.",
              link:"/"
            }
          ],
        gridData6 : [
            {
              img:"https://assets2.razerzone.com/images/pnx.assets/cf07588e1e08bf7767da32b1181bc4bf/thx-spatial-audio-category-500x500.jpg",
              title:"THX SPATIAL AUDIO",
              des:"Unlock full customization with a surround sound application featuring more extensive audio calibration and custom-tuned game profiles.",
              link:"/"
            },
            {
              img:"https://assets2.razerzone.com/images/pnx.assets/cf07588e1e08bf7767da32b1181bc4bf/71-surround-sound-category-500x500.jpg",
              title:"7.1 SURROUND SOUND",
              des:"Experience accurate positional sound for the competitive advantage.",
              link:"/"
            },
            {
              img:"https://assets2.razerzone.com/images/pnx.assets/cf07588e1e08bf7767da32b1181bc4bf/streamer-companion-app-category-500x500.jpg",
              title:"STREAMER COMPANION APP",
              des:"Put on a show for your stream by customizing how your Seiren Emote or Emote display reacts to your audience.",
              link:"/"
            }
          ],
      
    },
    categoryComp : {

        categoryComp1: {
            lgUrl:"https://assets2.razerzone.com/images/pnx.assets/6e289a72afea3e65be34ca0123930fff/complete-your-setup-campaign-hero-desktop.jpg",
            mdUrl:"https://assets2.razerzone.com/images/pnx.assets/6e289a72afea3e65be34ca0123930fff/complete-your-setup-campaign-hero-desktop.jpg",
            title:"COMPLETE YOUR SETUP",
            des:"A Color For Every Style",
            lUrl:"/"
        },
        // categoryComp2: {
        //     lgUrl:"https://assets2.razerzone.com/images/pnx.assets/6d5e42cc985b839667f80f80f88e6327/stay-in-sync-1920x700.jpg",
        //     mdUrl:"https://assets2.razerzone.com/images/pnx.assets/6d5e42cc985b839667f80f80f88e6327/stay-in-sync450x480.jpg",
        //     title:"STAY IN-SYNC WITH YOUR WORLD",
        //     des:"Whether you’re working from home or immersed in entertainment, our industry-leading Bluetooth low-latency audio deliver smooth, stutter-free sound and seamless connectivity.",
        //     lData:[{link:"/console",title:"View Over-Ear Headphones"},{link:"/",title:"View True Wireless Earbuds"}]
        // },
        // categoryComp3: {
        //     lgUrl:"https://assets2.razerzone.com/images/pnx.assets/8d15cb8a565e71ef01f047785d22ce69/gothe-extramile-category-1920x700-desktop.jpg",
        //     mdUrl:"https://assets2.razerzone.com/images/pnx.assets/8d15cb8a565e71ef01f047785d22ce69/gotheextramile-category-450x480-mobile.jpg",
        //     title:"GO THE EXTRA MILE",
        //     des:"When you’re filling those few minutes in line at the coffee shop or commuting to work with a quick game or listening to that banger on repeat, Razer has the accessory that lets fellow gamers know they’re among their own.",
        // }
    }
}


export default allData
